import { User } from 'shared/types';
import posthog from 'posthog-js';
import { useEffect } from 'react';
import { OrganizationRole } from 'features/users/users.types';
import { PlanType } from 'features/organizations/hooks/useOrganizationFeatureDialog';

type UsePostHogIdentification = {
  user?: User | null;
  isInternalUser: boolean;
};

type PosthogIdentifyData = {
  email?: string;
  name?: string;
  userGroups: string[];
  isInternalUser: boolean;
  isDonor: boolean;
  isMember: boolean;
  planType?: PlanType;
  organizations: number[];
  isInOrganization: boolean;
  organizationRoles: OrganizationRole[];
};

const getPosthogIdentifyData = (
  user: User | null,
  isInternalUser: boolean,
): PosthogIdentifyData | null => {
  if (!user) {
    return null;
  }

  const userGroupsNames = user.groups?.map((group) => group.name).sort();
  const organizationIds = user.organizations.map((org) => org.id).sort();

  return {
    email: user.email,
    name: user.displayName,
    userGroups: userGroupsNames || [],
    isInternalUser,
    isDonor: Boolean(user.supporterStatus?.isDonor),
    isMember: Boolean(user.supporterStatus?.hasActiveMembership),
    planType: user.supporterStatus?.planType || undefined,
    organizations: organizationIds,
    isInOrganization: Boolean(organizationIds.length),
    organizationRoles: user.organizations.map((org) => org.role) || [],
  };
};

export const usePostHogIdentification = (
  props: UsePostHogIdentification,
): void => {
  const { user, isInternalUser } = props;

  useEffect(() => {
    if (!user?.id) {
      return;
    }

    posthog.identify(
      `${user.id}`,
      getPosthogIdentifyData(user, isInternalUser) || undefined,
      // identifyData || undefined,
    );
  }, [user, isInternalUser]);
};
